export default __webpack_public_path__ + "static/BETA-vert-4dc88fbb30d14fc3f78ed6c8037df8df.svg";